var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f9fdf4885ab2ef1ee0f9c941e761e480300336dc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sv-hero-web@socialvenu"]={id:"f9fdf4885ab2ef1ee0f9c941e761e480300336dc"};
      